export const adminRoles = [
  'MAIN_ADMIN',
  'FEDERATION',
  'TOURNAMENT_ORGANIZER',
] as const;

export type AdminRole = (typeof adminRoles)[number];
export type UserStatus = 'PENDING_INVITE' | 'ACTIVE' | 'SUSPENDED';

export interface SessionUser {
  id: string;
  email: string;
  phone: string | null;
  role: AdminRole;
  status: UserStatus;
  createdAt: string;
  updatedAt: string;
}

export interface PageResult<T> {
  data: T[];
  page: number;
  pageSize: number;
  total: number;
}
